<template>
  <div class="p-6">
    <v-toolbar class="page-title" elevation="0">
      <v-tooltip bottom>
        <template v-slot:activator="{ on }">
          <v-btn class="mr-3" v-on="on" tile small>
            <v-icon left>fa fa-chevron-left</v-icon>
            Dashboard
          </v-btn>
        </template>
        <span> Go back </span>
      </v-tooltip>
      <v-btn small class="mr-4" color="primary">
        <v-icon class="mr-1" dark>fa fa-plus</v-icon>
        Create New Activity
      </v-btn>
      <slot name="actions"> </slot>
    </v-toolbar>
    <v-container>
      <div class="search-wrapper">
        <v-text-field
          v-model="search"
          label="Search..."
          prepend-inner-icon="fa fa-search"
          single-line
          outlined
          hide-details
          dense
        >
        </v-text-field>
        <small>
          Showing {{ searchResultsCount }} vegetables out of
          {{ Activities.length }}.
        </small>
      </div>
      <v-data-table
        v-model="selectedActivity"
        :headers="headers"
        :items="Activities"
        :search="search"
        item-key="name"
        class="elevation-1"
        @current-items="getFiltered"
      >
        <template v-slot:item.Actions="{ item }">
          <td>
            <v-icon small class="mr-2" @click="viewActivity(item)">
              fa fa-eye
            </v-icon>
            <v-icon small class="mr-2" @click="editActivity(item)">
              fa fa-clone
            </v-icon>
            <v-icon color="red" small @click="deleteActivity(item)">
              fa fa-trash
            </v-icon>
          </td>
        </template>
      </v-data-table>
    </v-container>
  </div>
</template>

<script>
import * as API from "./../../api";

export default {
  name: "Activities",
  methods: {
    getActivities() {
      this.$api
        .get(API.endpoints.activities)
        .then((response) => {
          this.Activities = response.data;
        })
        .catch((error) => {
          this.$notify({
            title: "Error",
            message: error,
            type: "danger",
          });
        });
    },

    viewActivity(item) {
      this.$router.push({ path: "activities/" + item.ID });
    },
    getFiltered(filtered) {
      this.searchResultsCount = filtered.length;
    },
  },
  data() {
    return {
      selectedActivity: "",
      search: "",
      newVegetableName: "",
      headers: [
        { text: "Id", value: "ID", align: "center" },
        { text: "Title", value: "Title", align: "center" },
        { text: "Due Date", value: "DueDate", align: "center" },
        { text: "Completed", value: "Completed" },
        { text: "Actions", value: "Actions" },
      ],
      Activities: [],
      searchResultsCount: 0,
    };
  },
  mounted() {
    this.getActivities();
  },
};
</script>

<style scoped>
.page-title {
  border-bottom: 1px solid rgba(219, 219, 219, 0.48);
  font-size: 15px;
}
</style>
